"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
// @ts-ignore
var react_symbol_1 = __importDefault(require("@wikom/react-symbol"));
var GridFilterDefaultTemplate = function (_a) {
    var clearFilter = _a.clearFilter, children = _a.children;
    return (react_1["default"].createElement("div", { className: "box box-default box-solid grid-search" },
        react_1["default"].createElement("div", { className: "box-header with-border" },
            react_1["default"].createElement("h3", { className: "box-title" }, "Filter"),
            react_1["default"].createElement("div", { className: "box-tools pull-right" },
                react_1["default"].createElement("button", { type: "button", onClick: clearFilter, className: "btn btn-xs btn-default btn-filterReset" },
                    react_1["default"].createElement(react_symbol_1["default"], { symbol: "undo" }),
                    " Filter zur\u00FCcksetzen"))),
        react_1["default"].createElement("div", { className: "box-body" },
            react_1["default"].createElement("div", { id: "filter_row", className: "row" }, children),
            react_1["default"].createElement("div", { id: "filter_apply_row", className: "filterapply-wrapper" },
                react_1["default"].createElement("button", { type: "submit", className: "btn btn-sm btn-primary" },
                    react_1["default"].createElement(react_symbol_1["default"], { symbol: "filter" }),
                    "Filter anwenden")))));
};
exports["default"] = GridFilterDefaultTemplate;
